var R = Object.defineProperty;
var j = (l, a, e) => a in l ? R(l, a, { enumerable: !0, configurable: !0, writable: !0, value: e }) : l[a] = e;
var P = (l, a, e) => j(l, typeof a != "symbol" ? a + "" : a, e);
import p from "axios";
const u = "http://localhost".replace(/\/+$/, "");
class k {
  constructor(a, e = u, s = p) {
    P(this, "configuration");
    this.basePath = e, this.axios = s, a && (this.configuration = a, this.basePath = a.basePath || this.basePath);
  }
}
class G extends Error {
  constructor(a, e) {
    super(e), this.field = a, this.name = "RequiredError";
  }
}
const m = "https://example.com", d = function(l, a, e) {
  if (e == null)
    throw new G(a, `Required parameter ${a} was null or undefined when calling ${l}.`);
};
function I(l, a, e = "") {
  a != null && (typeof a == "object" ? Array.isArray(a) ? a.forEach((s) => I(l, s, e)) : Object.keys(a).forEach(
    (s) => I(l, a[s], `${e}${e !== "" ? "." : ""}${s}`)
  ) : l.has(e) ? l.append(e, a) : l.set(e, a));
}
const U = function(l, ...a) {
  const e = new URLSearchParams(l.search);
  I(e, a), l.search = e.toString();
}, O = function(l, a, e) {
  const s = typeof l != "string";
  return (s && e && e.isJsonMime ? e.isJsonMime(a.headers["Content-Type"]) : s) ? JSON.stringify(l !== void 0 ? l : {}) : l || "";
}, V = function(l) {
  return l.pathname + l.search + l.hash;
}, w = function(l, a, e, s) {
  return (t = a, r = e) => {
    const o = { ...l.options, url: ((s == null ? void 0 : s.basePath) || r) + l.url };
    return t.request(o);
  };
}, S = {
  OWNER: "owner",
  ADMIN: "admin",
  CONTRIBUTOR: "contributor"
}, L = {
  TRAFFIC_ADDON: "traffic_addon",
  THROUGHPUT_ADDON: "throughput_addon",
  ARCHIVE_ADDON: "archive_addon",
  ARBITRUM: "arbitrum",
  OPTIMISM: "optimism",
  POLYGON: "polygon"
}, C = {
  INACTIVE: "STATUS_INACTIVE",
  ACTIVE: "STATUS_ACTIVE",
  DELETED: "STATUS_DELETED"
}, v = {
  CORE: "core",
  DEVELOPER: "developer",
  TEAM: "team",
  GROWTH: "growth",
  ENTERPRISE: "enterprise"
}, E = {
  UNSPECIFIED: "AL_UNSPECIFIED",
  ADDRESSES: "AL_ADDRESSES",
  USER_AGENTS: "AL_USER_AGENTS",
  ORIGINS: "AL_ORIGINS",
  METHODS: "AL_METHODS",
  IPS: "AL_IPS"
}, N = {
  UNSPECIFIED: "CREDITPLAN_UNSPECIFIED",
  REQUESTS: "CREDITPLAN_REQUESTS",
  CREDIT_UNITS: "CREDITPLAN_CREDIT_UNITS"
}, Q = {
  INACTIVE: "OP_INACTIVE",
  EQUAL: "OP_EQUAL",
  GREATER_THAN: "OP_GREATER_THAN",
  GREATER_EQUAL_THAN: "OP_GREATER_EQUAL_THAN",
  LESS_THAN: "OP_LESS_THAN",
  LESS_EQUAL_THAN: "OP_LESS_EQUAL_THAN",
  CONTAINS: "OP_CONTAINS"
}, g = {
  UNSPECIFIED: "SUBNET_UNSPECIFIED",
  MAINNET: "SUBNET_MAINNET",
  GOERLI: "SUBNET_GOERLI",
  GOERLI2: "SUBNET_GOERLI2",
  SEPOLIA: "SUBNET_SEPOLIA",
  ALFAJORES: "SUBNET_ALFAJORES",
  MUMBAI: "SUBNET_MUMBAI",
  FUJI: "SUBNET_FUJI",
  TESTNET: "SUBNET_TESTNET",
  AMOY: "SUBNET_AMOY",
  HOLESKY: "SUBNET_HOLESKY"
}, B = {
  UNSPECIFIED: "TP_UNSPECIFIED",
  PLAN: "TP_PLAN",
  NETWORKS: "TP_NETWORKS",
  LIMITS: "TP_LIMITS",
  ADDONS: "TP_ADDONS",
  CREDIT_TABLE: "TP_CREDIT_TABLE"
}, A = function(l) {
  return {
    /**
     * 
     * @summary Used to create an allowlists in the project
     * @param {string} projectId project id
     * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to be created
     * @param {string} item item to be inserted in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistsMethodsCreate: async (a, e, s, t = {}) => {
      d("allowlistsMethodsCreate", "projectId", a), d("allowlistsMethodsCreate", "listType", e), d("allowlistsMethodsCreate", "item", s);
      const r = "/api/v1/projects/{projectId}/allow_lists/{listType}/{item}".replace("{projectId}", encodeURIComponent(String(a))).replace("{listType}", encodeURIComponent(String(e))).replace("{item}", encodeURIComponent(String(s))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "POST", ...n, ...t }, c = {};
      U(o, {});
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to create an allowlists in the project with IPRange
     * @param {string} projectId project id
     * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to be created
     * @param {V1AllowIPRange} ipRange ip range to be inserted in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistsMethodsCreateIPRange: async (a, e, s, t = {}) => {
      d("allowlistsMethodsCreateIPRange", "projectId", a), d("allowlistsMethodsCreateIPRange", "listType", e), d("allowlistsMethodsCreateIPRange", "ipRange", s);
      const r = "/api/v1/projects/{projectId}/allow_lists/{listType}".replace("{projectId}", encodeURIComponent(String(a))).replace("{listType}", encodeURIComponent(String(e))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "POST", ...n, ...t }, c = {}, i = {};
      c["Content-Type"] = "application/json", U(o, i);
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, h.data = O(s, h, l), {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to remove an item from an allowlists in the project
     * @param {string} projectId project id
     * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to remove the item
     * @param {string} item item to be removed in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistsMethodsDelete: async (a, e, s, t = {}) => {
      d("allowlistsMethodsDelete", "projectId", a), d("allowlistsMethodsDelete", "listType", e), d("allowlistsMethodsDelete", "item", s);
      const r = "/api/v1/projects/{projectId}/allow_lists/{listType}/{item}".replace("{projectId}", encodeURIComponent(String(a))).replace("{listType}", encodeURIComponent(String(e))).replace("{item}", encodeURIComponent(String(s))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "PATCH", ...n, ...t }, c = {};
      U(o, {});
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to create an allowlists in the project with IPRange
     * @param {string} projectId project id
     * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to be created
     * @param {V1AllowIPRange} ipRange ip range to be inserted in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistsMethodsDeleteIPRange: async (a, e, s, t = {}) => {
      d("allowlistsMethodsDeleteIPRange", "projectId", a), d("allowlistsMethodsDeleteIPRange", "listType", e), d("allowlistsMethodsDeleteIPRange", "ipRange", s);
      const r = "/api/v1/projects/{projectId}/allow_lists/{listType}".replace("{projectId}", encodeURIComponent(String(a))).replace("{listType}", encodeURIComponent(String(e))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "PATCH", ...n, ...t }, c = {}, i = {};
      c["Content-Type"] = "application/json", U(o, i);
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, h.data = O(s, h, l), {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to fetch a single the allowlist
     * @param {string} projectId project id
     * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to remove the item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistsMethodsGet: async (a, e, s = {}) => {
      d("allowlistsMethodsGet", "projectId", a), d("allowlistsMethodsGet", "listType", e);
      const t = "/api/v1/projects/{projectId}/allow_lists/{listType}".replace("{projectId}", encodeURIComponent(String(a))).replace("{listType}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "GET", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to fetch all allowlists from the project
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistsMethodsList: async (a, e = {}) => {
      d("allowlistsMethodsList", "projectId", a);
      const s = "/api/v1/projects/{projectId}/allow_lists".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to update the allowlists_overridden in the project
     * @param {string} projectId project id
     * @param {AllowlistsMethodsUpdateRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistsMethodsUpdate: async (a, e, s = {}) => {
      d("allowlistsMethodsUpdate", "projectId", a), d("allowlistsMethodsUpdate", "body", e);
      const t = "/api/v1/projects/{projectId}/allow_lists".replace("{projectId}", encodeURIComponent(String(a))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "PUT", ...o, ...s }, h = {}, c = {};
      h["Content-Type"] = "application/json", U(r, c);
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, n.data = O(e, n, l), {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to delete the archive data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveMethodsDelete: async (a, e = {}) => {
      d("archiveMethodsDelete", "userId", a);
      const s = "/api/v1/users/{userId}/service_plan/limits/archive".replace("{userId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "DELETE", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to delete the archive data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveMethodsDeleteNetwork: async (a, e, s = {}) => {
      d("archiveMethodsDeleteNetwork", "userId", a), d("archiveMethodsDeleteNetwork", "networkId", e);
      const t = "/api/v1/users/{userId}/service_plan/limits/{networkId}/archive".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "DELETE", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to fetch the archive data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveMethodsGet: async (a, e = {}) => {
      d("archiveMethodsGet", "userId", a);
      const s = "/api/v1/users/{userId}/service_plan/limits/archive".replace("{userId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to fetch the archive data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveMethodsGetNetwork: async (a, e, s = {}) => {
      d("archiveMethodsGetNetwork", "userId", a), d("archiveMethodsGetNetwork", "networkId", e);
      const t = "/api/v1/users/{userId}/service_plan/limits/{networkId}/archive".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "GET", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to create/update the archive data
     * @param {string} userId user id
     * @param {V1Archive} archive archive data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveMethodsUpsert: async (a, e, s = {}) => {
      d("archiveMethodsUpsert", "userId", a), d("archiveMethodsUpsert", "archive", e);
      const t = "/api/v1/users/{userId}/service_plan/limits/archive".replace("{userId}", encodeURIComponent(String(a))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "PUT", ...o, ...s }, h = {}, c = {};
      h["Content-Type"] = "application/json", U(r, c);
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, n.data = O(e, n, l), {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to create/update the archive data in a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {V1Archive} archive archive data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveMethodsUpsertNetwork: async (a, e, s, t = {}) => {
      d("archiveMethodsUpsertNetwork", "userId", a), d("archiveMethodsUpsertNetwork", "networkId", e), d("archiveMethodsUpsertNetwork", "archive", s);
      const r = "/api/v1/users/{userId}/service_plan/limits/{networkId}/archive".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "PUT", ...n, ...t }, c = {}, i = {};
      c["Content-Type"] = "application/json", U(o, i);
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, h.data = O(s, h, l), {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to fetch the user Auth object using a custom key id
     * @param {string} customKeyId custom key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authMethodsGetByCustomKey: async (a, e = {}) => {
      d("authMethodsGetByCustomKey", "customKeyId", a);
      const s = "/api/v1/auth/custom_key/{customKeyId}".replace("{customKeyId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to fetch the user Auth object using the project id (key) and the jwt id
     * @param {V1AuthMethodsGetByJwtRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authMethodsGetByJwt: async (a, e = {}) => {
      d("authMethodsGetByJwt", "body", a);
      const s = "/api/v1/auth/jwt", t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "POST", ...r, ...e }, n = {}, h = {};
      n["Content-Type"] = "application/json", U(t, h);
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, o.data = O(a, o, l), {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to fetch the user Auth object using the project id (key)
     * @param {V1AuthMethodsGetByPublicKeyRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authMethodsGetByPublicKey: async (a, e = {}) => {
      d("authMethodsGetByPublicKey", "body", a);
      const s = "/api/v1/auth/public_key", t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "POST", ...r, ...e }, n = {}, h = {};
      n["Content-Type"] = "application/json", U(t, h);
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, o.data = O(a, o, l), {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to fetch the user Auth object using the project id (key) and the secret
     * @param {V1AuthMethodsGetBySecretRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authMethodsGetBySecret: async (a, e = {}) => {
      d("authMethodsGetBySecret", "body", a);
      const s = "/api/v1/auth/secret", t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "POST", ...r, ...e }, n = {}, h = {};
      n["Content-Type"] = "application/json", U(t, h);
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, o.data = O(a, o, l), {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to fetch the basic project information
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    basicMethodsGet: async (a, e = {}) => {
      d("basicMethodsGet", "projectId", a);
      const s = "/api/v1/projects/{projectId}/basic".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to create/update the basic project information
     * @param {string} projectId project id
     * @param {V1Basic} basic basic project information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    basicMethodsUpsert: async (a, e, s = {}) => {
      d("basicMethodsUpsert", "projectId", a), d("basicMethodsUpsert", "basic", e);
      const t = "/api/v1/projects/{projectId}/basic".replace("{projectId}", encodeURIComponent(String(a))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "PUT", ...o, ...s }, h = {}, c = {};
      h["Content-Type"] = "application/json", U(r, c);
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, n.data = O(e, n, l), {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to delete the credit units data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditUnitsMethodsDelete: async (a, e = {}) => {
      d("creditUnitsMethodsDelete", "userId", a);
      const s = "/api/v1/users/{userId}/service_plan/limits/credit_units".replace("{userId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "DELETE", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to delete the credit units data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditUnitsMethodsDeleteNetwork: async (a, e, s = {}) => {
      d("creditUnitsMethodsDeleteNetwork", "userId", a), d("creditUnitsMethodsDeleteNetwork", "networkId", e);
      const t = "/api/v1/users/{userId}/service_plan/limits/{networkId}/credit_units".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "DELETE", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to fetch the credit units data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditUnitsMethodsGet: async (a, e = {}) => {
      d("creditUnitsMethodsGet", "userId", a);
      const s = "/api/v1/users/{userId}/service_plan/limits/credit_units".replace("{userId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to fetch the credit units data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditUnitsMethodsGetNetwork: async (a, e, s = {}) => {
      d("creditUnitsMethodsGetNetwork", "userId", a), d("creditUnitsMethodsGetNetwork", "networkId", e);
      const t = "/api/v1/users/{userId}/service_plan/limits/{networkId}/credit_units".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "GET", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to create/update the credit units data
     * @param {string} userId user id
     * @param {V1CreditUnits} creditUnits 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditUnitsMethodsUpsert: async (a, e, s = {}) => {
      d("creditUnitsMethodsUpsert", "userId", a), d("creditUnitsMethodsUpsert", "creditUnits", e);
      const t = "/api/v1/users/{userId}/service_plan/limits/credit_units".replace("{userId}", encodeURIComponent(String(a))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "PATCH", ...o, ...s }, h = {}, c = {};
      h["Content-Type"] = "application/json", U(r, c);
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, n.data = O(e, n, l), {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to create/update the credit units data in a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {V1CreditUnits} creditUnits 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditUnitsMethodsUpsertNetwork: async (a, e, s, t = {}) => {
      d("creditUnitsMethodsUpsertNetwork", "userId", a), d("creditUnitsMethodsUpsertNetwork", "networkId", e), d("creditUnitsMethodsUpsertNetwork", "creditUnits", s);
      const r = "/api/v1/users/{userId}/service_plan/limits/{networkId}/credit_units".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "PATCH", ...n, ...t }, c = {}, i = {};
      c["Content-Type"] = "application/json", U(o, i);
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, h.data = O(s, h, l), {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to delete the custom key
     * @param {string} customKeyId custom key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customKeyMethodsDelete: async (a, e = {}) => {
      d("customKeyMethodsDelete", "customKeyId", a);
      const s = "/api/v1/custom_key/{customKeyId}".replace("{customKeyId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "DELETE", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to fetch the custom key information
     * @param {string} customKeyId custom key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customKeyMethodsGet: async (a, e = {}) => {
      d("customKeyMethodsGet", "customKeyId", a);
      const s = "/api/v1/custom_key/{customKeyId}".replace("{customKeyId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to create/update the custom key
     * @param {V1CustomKey} customKey custom key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customKeyMethodsUpsert: async (a, e = {}) => {
      d("customKeyMethodsUpsert", "customKey", a);
      const s = "/api/v1/custom_key", t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "PUT", ...r, ...e }, n = {}, h = {};
      n["Content-Type"] = "application/json", U(t, h);
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, o.data = O(a, o, l), {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to delete a specific entitlment
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {string} entitlementId generally the of the entitlement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entitlementMethodsDelete: async (a, e, s, t = {}) => {
      d("entitlementMethodsDelete", "userId", a), d("entitlementMethodsDelete", "networkId", e), d("entitlementMethodsDelete", "entitlementId", s);
      const r = "/api/v1/users/{userId}/service_plan/networks/{networkId}/entitlements/{entitlementId}".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))).replace("{entitlementId}", encodeURIComponent(String(s))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "DELETE", ...n, ...t }, c = {};
      U(o, {});
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to fetch a specific entitlment
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {string} entitlementId generally the of the entitlement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entitlementMethodsGet: async (a, e, s, t = {}) => {
      d("entitlementMethodsGet", "userId", a), d("entitlementMethodsGet", "networkId", e), d("entitlementMethodsGet", "entitlementId", s);
      const r = "/api/v1/users/{userId}/service_plan/networks/{networkId}/entitlements/{entitlementId}".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))).replace("{entitlementId}", encodeURIComponent(String(s))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "GET", ...n, ...t }, c = {};
      U(o, {});
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to fetch all entitlments
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;near\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entitlementMethodsList: async (a, e, s = {}) => {
      d("entitlementMethodsList", "userId", a), d("entitlementMethodsList", "networkId", e);
      const t = "/api/v1/users/{userId}/service_plan/networks/{networkId}/entitlements".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "GET", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to create/update a specific entitlment
     * @param {string} userId user id
     * @param {string} networkId network e.g.: \&quot;nft\&quot;
     * @param {string} entitlementId generally the of the entitlement
     * @param {V1Entitlement} entitlement entitlement info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entitlementMethodsUpsert: async (a, e, s, t, r = {}) => {
      d("entitlementMethodsUpsert", "userId", a), d("entitlementMethodsUpsert", "networkId", e), d("entitlementMethodsUpsert", "entitlementId", s), d("entitlementMethodsUpsert", "entitlement", t);
      const o = "/api/v1/users/{userId}/service_plan/networks/{networkId}/entitlements/{entitlementId}".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))).replace("{entitlementId}", encodeURIComponent(String(s))), n = new URL(o, m);
      let h;
      l && (h = l.baseOptions);
      const c = { method: "PUT", ...h, ...r }, i = {}, y = {};
      i["Content-Type"] = "application/json", U(n, y);
      let b = h && h.headers ? h.headers : {};
      return c.headers = { ...i, ...b, ...r.headers }, c.data = O(t, c, l), {
        url: V(n),
        options: c
      };
    },
    /**
     * 
     * @summary Used to delete a dedicated gateway
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gatewayMethodsDelete: async (a, e = {}) => {
      d("gatewayMethodsDelete", "projectId", a);
      const s = "/api/v1/projects/{projectId}/gateway".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "DELETE", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to fetch the dedicated gateway information
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gatewayMethodsGet: async (a, e = {}) => {
      d("gatewayMethodsGet", "projectId", a);
      const s = "/api/v1/projects/{projectId}/gateway".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to create/update the dedicated gateway information
     * @param {string} projectId project id
     * @param {V1Gateway} gateway dedicated gateway data to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gatewayMethodsUpsert: async (a, e, s = {}) => {
      d("gatewayMethodsUpsert", "projectId", a), d("gatewayMethodsUpsert", "gateway", e);
      const t = "/api/v1/projects/{projectId}/gateway".replace("{projectId}", encodeURIComponent(String(a))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "PUT", ...o, ...s }, h = {}, c = {};
      h["Content-Type"] = "application/json", U(r, c);
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, n.data = O(e, n, l), {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to create a JWT
     * @param {string} projectId project id
     * @param {V1JWTDetail} jwt JWT Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    jWTMethodsCreate: async (a, e, s = {}) => {
      d("jWTMethodsCreate", "projectId", a), d("jWTMethodsCreate", "jwt", e);
      const t = "/api/v1/projects/{projectId}/jwt".replace("{projectId}", encodeURIComponent(String(a))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "POST", ...o, ...s }, h = {}, c = {};
      h["Content-Type"] = "application/json", U(r, c);
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, n.data = O(e, n, l), {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to delete a JWT
     * @param {string} projectId project id
     * @param {string} jwtId jwt id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    jWTMethodsDelete: async (a, e, s = {}) => {
      d("jWTMethodsDelete", "projectId", a), d("jWTMethodsDelete", "jwtId", e);
      const t = "/api/v1/projects/{projectId}/jwt/{jwtId}".replace("{projectId}", encodeURIComponent(String(a))).replace("{jwtId}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "DELETE", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to list the JWTs in a project
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    jWTMethodsList: async (a, e = {}) => {
      d("jWTMethodsList", "projectId", a);
      const s = "/api/v1/projects/{projectId}/jwt".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to remove all limits existent within in a user which will force to use a template
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    limitsMethodsDelete: async (a, e = {}) => {
      d("limitsMethodsDelete", "userId", a);
      const s = "/api/v1/users/{userId}/service_plan/limits".replace("{userId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "DELETE", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to remove all limits existent within in a user which will force to use a template
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    limitsMethodsDeleteNetwork: async (a, e, s = {}) => {
      d("limitsMethodsDeleteNetwork", "userId", a), d("limitsMethodsDeleteNetwork", "networkId", e);
      const t = "/api/v1/users/{userId}/service_plan/limits/{networkId}".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "DELETE", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to fetch all limits in a tier
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    limitsMethodsList: async (a, e = {}) => {
      d("limitsMethodsList", "userId", a);
      const s = "/api/v1/users/{userId}/service_plan/limits".replace("{userId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to a delete a network
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networkMethodsDelete: async (a, e, s = {}) => {
      d("networkMethodsDelete", "userId", a), d("networkMethodsDelete", "networkId", e);
      const t = "/api/v1/users/{userId}/service_plan/networks/{networkId}".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "DELETE", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to remove a subnet
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {'SUBNET_UNSPECIFIED' | 'SUBNET_MAINNET' | 'SUBNET_GOERLI' | 'SUBNET_GOERLI2' | 'SUBNET_SEPOLIA' | 'SUBNET_ALFAJORES' | 'SUBNET_MUMBAI' | 'SUBNET_FUJI' | 'SUBNET_TESTNET' | 'SUBNET_AMOY' | 'SUBNET_HOLESKY'} subnetId subnet to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networkMethodsDeleteSubnet: async (a, e, s, t = {}) => {
      d("networkMethodsDeleteSubnet", "userId", a), d("networkMethodsDeleteSubnet", "networkId", e), d("networkMethodsDeleteSubnet", "subnetId", s);
      const r = "/api/v1/users/{userId}/service_plan/networks/{networkId}/subnets/{subnetId}".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))).replace("{subnetId}", encodeURIComponent(String(s))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "DELETE", ...n, ...t }, c = {};
      U(o, {});
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to fetch a single network
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networkMethodsGet: async (a, e, s = {}) => {
      d("networkMethodsGet", "userId", a), d("networkMethodsGet", "networkId", e);
      const t = "/api/v1/users/{userId}/service_plan/networks/{networkId}".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "GET", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to fetch all networks
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networkMethodsList: async (a, e = {}) => {
      d("networkMethodsList", "userId", a);
      const s = "/api/v1/users/{userId}/service_plan/networks".replace("{userId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to insert/update a subnet
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {{ [key: string]: V1Subnet; }} subnets List of subnets to insert/update, the key should be a SubnetType bcoz the proto3 dont allow us to use enums as key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networkMethodsUpdateSubnet: async (a, e, s, t = {}) => {
      d("networkMethodsUpdateSubnet", "userId", a), d("networkMethodsUpdateSubnet", "networkId", e), d("networkMethodsUpdateSubnet", "subnets", s);
      const r = "/api/v1/users/{userId}/service_plan/networks/{networkId}/subnets".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "PUT", ...n, ...t }, c = {}, i = {};
      c["Content-Type"] = "application/json", U(o, i);
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, h.data = O(s, h, l), {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to create/update a network
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {V1Network} network // the full network data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networkMethodsUpsert: async (a, e, s, t = {}) => {
      d("networkMethodsUpsert", "userId", a), d("networkMethodsUpsert", "networkId", e), d("networkMethodsUpsert", "network", s);
      const r = "/api/v1/users/{userId}/service_plan/networks/{networkId}".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "PUT", ...n, ...t }, c = {}, i = {};
      c["Content-Type"] = "application/json", U(o, i);
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, h.data = O(s, h, l), {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to create a network in the project
     * @param {string} projectId project id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {'SUBNET_UNSPECIFIED' | 'SUBNET_MAINNET' | 'SUBNET_GOERLI' | 'SUBNET_GOERLI2' | 'SUBNET_SEPOLIA' | 'SUBNET_ALFAJORES' | 'SUBNET_MUMBAI' | 'SUBNET_FUJI' | 'SUBNET_TESTNET' | 'SUBNET_AMOY' | 'SUBNET_HOLESKY'} subnet subnet to be inserted in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networksMethodsCreate: async (a, e, s, t = {}) => {
      d("networksMethodsCreate", "projectId", a), d("networksMethodsCreate", "networkId", e), d("networksMethodsCreate", "subnet", s);
      const r = "/api/v1/projects/{projectId}/networks/{networkId}/{subnet}".replace("{projectId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))).replace("{subnet}", encodeURIComponent(String(s))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "POST", ...n, ...t }, c = {};
      U(o, {});
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to remove an item from a network in the project
     * @param {string} projectId project id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {'SUBNET_UNSPECIFIED' | 'SUBNET_MAINNET' | 'SUBNET_GOERLI' | 'SUBNET_GOERLI2' | 'SUBNET_SEPOLIA' | 'SUBNET_ALFAJORES' | 'SUBNET_MUMBAI' | 'SUBNET_FUJI' | 'SUBNET_TESTNET' | 'SUBNET_AMOY' | 'SUBNET_HOLESKY'} subnet subnet to be removed from the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networksMethodsDelete: async (a, e, s, t = {}) => {
      d("networksMethodsDelete", "projectId", a), d("networksMethodsDelete", "networkId", e), d("networksMethodsDelete", "subnet", s);
      const r = "/api/v1/projects/{projectId}/networks/{networkId}/{subnet}".replace("{projectId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))).replace("{subnet}", encodeURIComponent(String(s))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "DELETE", ...n, ...t }, c = {};
      U(o, {});
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to fetch a single the network
     * @param {string} projectId project id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networksMethodsGet: async (a, e, s = {}) => {
      d("networksMethodsGet", "projectId", a), d("networksMethodsGet", "networkId", e);
      const t = "/api/v1/projects/{projectId}/networks/{networkId}".replace("{projectId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "GET", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to fetch all networks from the project
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networksMethodsList: async (a, e = {}) => {
      d("networksMethodsList", "projectId", a);
      const s = "/api/v1/projects/{projectId}/networks".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to delete a specific project
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectMethodsDelete: async (a, e = {}) => {
      d("projectMethodsDelete", "projectId", a);
      const s = "/api/v1/projects/{projectId}".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "DELETE", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to remove a subnet
     * @param {string} projectId project id
     * @param {string} networkId network id
     * @param {Array<V1SubnetType>} subnets List of subnet to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectMethodsDeleteSubnets: async (a, e, s, t = {}) => {
      d("projectMethodsDeleteSubnets", "projectId", a), d("projectMethodsDeleteSubnets", "networkId", e), d("projectMethodsDeleteSubnets", "subnets", s);
      const r = "/api/v1/projects/{projectId}/subnets/{networkId}".replace("{projectId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "PATCH", ...n, ...t }, c = {}, i = {};
      c["Content-Type"] = "application/json", U(o, i);
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, h.data = O(s, h, l), {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to fetch a specific project
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectMethodsGet: async (a, e = {}) => {
      d("projectMethodsGet", "projectId", a);
      const s = "/api/v1/projects/{projectId}".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to fetch all user projects
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectMethodsList: async (a, e = {}) => {
      d("projectMethodsList", "userId", a);
      const s = "/api/v1/users/{userId}/projects".replace("{userId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to insert a subnet
     * @param {string} projectId project id
     * @param {Array<V1SubnetType>} subnets List of subnet to update
     * @param {string} [networkId] network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectMethodsUpdateSubnets: async (a, e, s, t = {}) => {
      d("projectMethodsUpdateSubnets", "projectId", a), d("projectMethodsUpdateSubnets", "subnets", e);
      const r = "/api/v1/projects/{projectId}/subnets".replace("{projectId}", encodeURIComponent(String(a))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "PUT", ...n, ...t }, c = {}, i = {};
      s !== void 0 && (i.networkId = s), c["Content-Type"] = "application/json", U(o, i);
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, h.data = O(e, h, l), {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to create/update a specific project
     * @param {V1Project} project project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectMethodsUpsert: async (a, e = {}) => {
      d("projectMethodsUpsert", "project", a);
      const s = "/api/v1/project", t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "PUT", ...r, ...e }, n = {}, h = {};
      n["Content-Type"] = "application/json", U(t, h);
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, o.data = O(a, o, l), {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to create/update a list of projects
     * @param {V1Projects} projects list of user projects
     * @param {string} [userId] user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectMethodsUpsertList: async (a, e, s = {}) => {
      d("projectMethodsUpsertList", "projects", a);
      const t = "/api/v1/projects", r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "PUT", ...o, ...s }, h = {}, c = {};
      e !== void 0 && (c.userId = e), h["Content-Type"] = "application/json", U(r, c);
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, n.data = O(a, n, l), {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to delete quotas
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quotasMethodsDelete: async (a, e = {}) => {
      d("quotasMethodsDelete", "projectId", a);
      const s = "/api/v1/projects/{projectId}/quotas".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "DELETE", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to fetch quotas information
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quotasMethodsGet: async (a, e = {}) => {
      d("quotasMethodsGet", "projectId", a);
      const s = "/api/v1/projects/{projectId}/quotas".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "POST", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to create/update quotas information
     * @param {string} projectId project id
     * @param {V1Quotas} quotas quotas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quotasMethodsUpsert: async (a, e, s = {}) => {
      d("quotasMethodsUpsert", "projectId", a), d("quotasMethodsUpsert", "quotas", e);
      const t = "/api/v1/projects/{projectId}/quotas".replace("{projectId}", encodeURIComponent(String(a))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "PUT", ...o, ...s }, h = {}, c = {};
      h["Content-Type"] = "application/json", U(r, c);
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, n.data = O(e, n, l), {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to delete rate limit informations
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rateLimitMethodsDelete: async (a, e = {}) => {
      d("rateLimitMethodsDelete", "projectId", a);
      const s = "/api/v1/projects/{projectId}/rate_limit".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "DELETE", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to fetch rate limit information
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rateLimitMethodsGet: async (a, e = {}) => {
      d("rateLimitMethodsGet", "projectId", a);
      const s = "/api/v1/projects/{projectId}/rate_limit".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to create/update rate limit information
     * @param {string} projectId project id
     * @param {V1RateLimit} rateLimit rate limit data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rateLimitMethodsUpsert: async (a, e, s = {}) => {
      d("rateLimitMethodsUpsert", "projectId", a), d("rateLimitMethodsUpsert", "rateLimit", e);
      const t = "/api/v1/projects/{projectId}/rate_limit".replace("{projectId}", encodeURIComponent(String(a))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "PUT", ...o, ...s }, h = {}, c = {};
      h["Content-Type"] = "application/json", U(r, c);
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, n.data = O(e, n, l), {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to generate a new secret
     * @param {string} projectId project id
     * @param {V1Security} security If this security object changes the secret will be other
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    securityMethodsGenerate: async (a, e, s = {}) => {
      d("securityMethodsGenerate", "projectId", a), d("securityMethodsGenerate", "security", e);
      const t = "/api/v1/projects/{projectId}/security/generate".replace("{projectId}", encodeURIComponent(String(a))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "POST", ...o, ...s }, h = {}, c = {};
      h["Content-Type"] = "application/json", U(r, c);
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, n.data = O(e, n, l), {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to fetch the secret
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    securityMethodsGet: async (a, e = {}) => {
      d("securityMethodsGet", "projectId", a);
      const s = "/api/v1/projects/{projectId}/security".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to verify if the secret informed is valid
     * @param {string} projectId project id
     * @param {string} secret secret to be verified
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    securityMethodsVerify: async (a, e, s = {}) => {
      d("securityMethodsVerify", "projectId", a), d("securityMethodsVerify", "secret", e);
      const t = "/api/v1/projects/{projectId}/security/verify/{secret}".replace("{projectId}", encodeURIComponent(String(a))).replace("{secret}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "PATCH", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to fetch the user service plan
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceMethodsGet: async (a, e = {}) => {
      d("serviceMethodsGet", "userId", a);
      const s = "/api/v1/users/{userId}/service_plan".replace("{userId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to create/update the user service plan
     * @param {V1Service} servicePlan the full service plan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceMethodsUpsert: async (a, e = {}) => {
      d("serviceMethodsUpsert", "servicePlan", a);
      const s = "/api/v1/service_plan", t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "PUT", ...r, ...e }, n = {}, h = {};
      n["Content-Type"] = "application/json", U(t, h);
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, o.data = O(a, o, l), {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to fetch all settings information
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    settingsMethodsList: async (a, e = {}) => {
      d("settingsMethodsList", "projectId", a);
      const s = "/api/v1/projects/{projectId}/settings".replace("{projectId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to delete the storage data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    storageMethodsDelete: async (a, e = {}) => {
      d("storageMethodsDelete", "userId", a);
      const s = "/api/v1/users/{userId}/service_plan/limits/storage".replace("{userId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "DELETE", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to delete the storage data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    storageMethodsDeleteNetwork: async (a, e, s = {}) => {
      d("storageMethodsDeleteNetwork", "userId", a), d("storageMethodsDeleteNetwork", "networkId", e);
      const t = "/api/v1/users/{userId}/service_plan/limits/{networkId}/storage".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "DELETE", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to fetch the storage data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    storageMethodsGet: async (a, e = {}) => {
      d("storageMethodsGet", "userId", a);
      const s = "/api/v1/users/{userId}/service_plan/limits/storage".replace("{userId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to fetch the storage data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    storageMethodsGetNetwork: async (a, e, s = {}) => {
      d("storageMethodsGetNetwork", "userId", a), d("storageMethodsGetNetwork", "networkId", e);
      const t = "/api/v1/users/{userId}/service_plan/limits/{networkId}/storage".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "GET", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to create/update the storage data
     * @param {string} userId user id
     * @param {V1Storage} storage storage data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    storageMethodsUpsert: async (a, e, s = {}) => {
      d("storageMethodsUpsert", "userId", a), d("storageMethodsUpsert", "storage", e);
      const t = "/api/v1/users/{userId}/service_plan/limits/storage".replace("{userId}", encodeURIComponent(String(a))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "PUT", ...o, ...s }, h = {}, c = {};
      h["Content-Type"] = "application/json", U(r, c);
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, n.data = O(e, n, l), {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to create/update the storage data in a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {V1Storage} storage storage data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    storageMethodsUpsertNetwork: async (a, e, s, t = {}) => {
      d("storageMethodsUpsertNetwork", "userId", a), d("storageMethodsUpsertNetwork", "networkId", e), d("storageMethodsUpsertNetwork", "storage", s);
      const r = "/api/v1/users/{userId}/service_plan/limits/{networkId}/storage".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "PUT", ...n, ...t }, c = {}, i = {};
      c["Content-Type"] = "application/json", U(o, i);
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, h.data = O(s, h, l), {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @summary Used to fetch the template
     * @param {'TP_UNSPECIFIED' | 'TP_PLAN' | 'TP_NETWORKS' | 'TP_LIMITS' | 'TP_ADDONS' | 'TP_CREDIT_TABLE'} type template type
     * @param {string} templateId template id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templateMethodsGet: async (a, e, s = {}) => {
      d("templateMethodsGet", "type", a), d("templateMethodsGet", "templateId", e);
      const t = "/api/v1/templates/{type}/{templateId}".replace("{type}", encodeURIComponent(String(a))).replace("{templateId}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "GET", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to list all templates by type
     * @param {'TP_UNSPECIFIED' | 'TP_PLAN' | 'TP_NETWORKS' | 'TP_LIMITS' | 'TP_ADDONS' | 'TP_CREDIT_TABLE'} type template type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templateMethodsList: async (a, e = {}) => {
      d("templateMethodsList", "type", a);
      const s = "/api/v1/templates/{type}".replace("{type}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to create/update the template
     * @param {V1Template} template the full template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templateMethodsUpsert: async (a, e = {}) => {
      d("templateMethodsUpsert", "template", a);
      const s = "/api/v1/templates", t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "PUT", ...r, ...e }, n = {}, h = {};
      n["Content-Type"] = "application/json", U(t, h);
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, o.data = O(a, o, l), {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to delete the traffic data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trafficMethodsDelete: async (a, e = {}) => {
      d("trafficMethodsDelete", "userId", a);
      const s = "/api/v1/users/{userId}/service_plan/limits/traffic".replace("{userId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "DELETE", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to delete the traffic data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trafficMethodsDeleteNetwork: async (a, e, s = {}) => {
      d("trafficMethodsDeleteNetwork", "userId", a), d("trafficMethodsDeleteNetwork", "networkId", e);
      const t = "/api/v1/users/{userId}/service_plan/limits/{networkId}/traffic".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "DELETE", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to fetch the traffic data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trafficMethodsGet: async (a, e = {}) => {
      d("trafficMethodsGet", "userId", a);
      const s = "/api/v1/users/{userId}/service_plan/limits/traffic".replace("{userId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @summary Used to fetch the traffic data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trafficMethodsGetNetwork: async (a, e, s = {}) => {
      d("trafficMethodsGetNetwork", "userId", a), d("trafficMethodsGetNetwork", "networkId", e);
      const t = "/api/v1/users/{userId}/service_plan/limits/{networkId}/traffic".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "GET", ...o, ...s }, h = {};
      U(r, {});
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to create/update the traffic data
     * @param {string} userId user id
     * @param {V1Traffic} traffic traffic data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trafficMethodsUpsert: async (a, e, s = {}) => {
      d("trafficMethodsUpsert", "userId", a), d("trafficMethodsUpsert", "traffic", e);
      const t = "/api/v1/users/{userId}/service_plan/limits/traffic".replace("{userId}", encodeURIComponent(String(a))), r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "PUT", ...o, ...s }, h = {}, c = {};
      h["Content-Type"] = "application/json", U(r, c);
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, n.data = O(e, n, l), {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to create/update the traffic data in a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {V1Traffic} traffic traffic data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trafficMethodsUpsertNetwork: async (a, e, s, t = {}) => {
      d("trafficMethodsUpsertNetwork", "userId", a), d("trafficMethodsUpsertNetwork", "networkId", e), d("trafficMethodsUpsertNetwork", "traffic", s);
      const r = "/api/v1/users/{userId}/service_plan/limits/{networkId}/traffic".replace("{userId}", encodeURIComponent(String(a))).replace("{networkId}", encodeURIComponent(String(e))), o = new URL(r, m);
      let n;
      l && (n = l.baseOptions);
      const h = { method: "PUT", ...n, ...t }, c = {}, i = {};
      c["Content-Type"] = "application/json", U(o, i);
      let y = n && n.headers ? n.headers : {};
      return h.headers = { ...c, ...y, ...t.headers }, h.data = O(s, h, l), {
        url: V(o),
        options: h
      };
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usageTrackerMethodsGetCreditMap: async (a = {}) => {
      const e = "/api/v1/usage_tracker/credit_map", s = new URL(e, m);
      let t;
      l && (t = l.baseOptions);
      const r = { method: "GET", ...t, ...a }, o = {};
      U(s, {});
      let h = t && t.headers ? t.headers : {};
      return r.headers = { ...o, ...h, ...a.headers }, {
        url: V(s),
        options: r
      };
    },
    /**
     * 
     * @param {V1PublishRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usageTrackerMethodsPublishAtomic: async (a, e = {}) => {
      d("usageTrackerMethodsPublishAtomic", "body", a);
      const s = "/api/v1/usage_tracker/publish_atomic", t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "POST", ...r, ...e }, n = {}, h = {};
      n["Content-Type"] = "application/json", U(t, h);
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, o.data = O(a, o, l), {
        url: V(t),
        options: o
      };
    },
    /**
     * 
     * @param {Array<string>} [keys] 
     * @param {string} [userId] user_id to use as cache hash to group the values in the same slot
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usageTrackerMethodsQueryMemory: async (a, e, s = {}) => {
      const t = "/api/v1/usage_tracker/query_memory", r = new URL(t, m);
      let o;
      l && (o = l.baseOptions);
      const n = { method: "GET", ...o, ...s }, h = {}, c = {};
      a && (c.keys = a), e !== void 0 && (c.userId = e), U(r, c);
      let i = o && o.headers ? o.headers : {};
      return n.headers = { ...h, ...i, ...s.headers }, {
        url: V(r),
        options: n
      };
    },
    /**
     * 
     * @summary Used to fetch the User object using the user id
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userMethodsGet: async (a, e = {}) => {
      d("userMethodsGet", "userId", a);
      const s = "/api/v1/users/{userId}".replace("{userId}", encodeURIComponent(String(a))), t = new URL(s, m);
      let r;
      l && (r = l.baseOptions);
      const o = { method: "GET", ...r, ...e }, n = {};
      U(t, {});
      let c = r && r.headers ? r.headers : {};
      return o.headers = { ...n, ...c, ...e.headers }, {
        url: V(t),
        options: o
      };
    }
  };
}, M = function(l) {
  const a = A(l);
  return {
    /**
     * 
     * @summary Used to create an allowlists in the project
     * @param {string} projectId project id
     * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to be created
     * @param {string} item item to be inserted in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async allowlistsMethodsCreate(e, s, t, r) {
      const o = await a.allowlistsMethodsCreate(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to create an allowlists in the project with IPRange
     * @param {string} projectId project id
     * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to be created
     * @param {V1AllowIPRange} ipRange ip range to be inserted in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async allowlistsMethodsCreateIPRange(e, s, t, r) {
      const o = await a.allowlistsMethodsCreateIPRange(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to remove an item from an allowlists in the project
     * @param {string} projectId project id
     * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to remove the item
     * @param {string} item item to be removed in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async allowlistsMethodsDelete(e, s, t, r) {
      const o = await a.allowlistsMethodsDelete(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to create an allowlists in the project with IPRange
     * @param {string} projectId project id
     * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to be created
     * @param {V1AllowIPRange} ipRange ip range to be inserted in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async allowlistsMethodsDeleteIPRange(e, s, t, r) {
      const o = await a.allowlistsMethodsDeleteIPRange(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch a single the allowlist
     * @param {string} projectId project id
     * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to remove the item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async allowlistsMethodsGet(e, s, t) {
      const r = await a.allowlistsMethodsGet(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch all allowlists from the project
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async allowlistsMethodsList(e, s) {
      const t = await a.allowlistsMethodsList(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to update the allowlists_overridden in the project
     * @param {string} projectId project id
     * @param {AllowlistsMethodsUpdateRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async allowlistsMethodsUpdate(e, s, t) {
      const r = await a.allowlistsMethodsUpdate(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to delete the archive data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async archiveMethodsDelete(e, s) {
      const t = await a.archiveMethodsDelete(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to delete the archive data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async archiveMethodsDeleteNetwork(e, s, t) {
      const r = await a.archiveMethodsDeleteNetwork(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the archive data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async archiveMethodsGet(e, s) {
      const t = await a.archiveMethodsGet(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the archive data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async archiveMethodsGetNetwork(e, s, t) {
      const r = await a.archiveMethodsGetNetwork(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update the archive data
     * @param {string} userId user id
     * @param {V1Archive} archive archive data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async archiveMethodsUpsert(e, s, t) {
      const r = await a.archiveMethodsUpsert(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update the archive data in a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {V1Archive} archive archive data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async archiveMethodsUpsertNetwork(e, s, t, r) {
      const o = await a.archiveMethodsUpsertNetwork(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the user Auth object using a custom key id
     * @param {string} customKeyId custom key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authMethodsGetByCustomKey(e, s) {
      const t = await a.authMethodsGetByCustomKey(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the user Auth object using the project id (key) and the jwt id
     * @param {V1AuthMethodsGetByJwtRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authMethodsGetByJwt(e, s) {
      const t = await a.authMethodsGetByJwt(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the user Auth object using the project id (key)
     * @param {V1AuthMethodsGetByPublicKeyRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authMethodsGetByPublicKey(e, s) {
      const t = await a.authMethodsGetByPublicKey(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the user Auth object using the project id (key) and the secret
     * @param {V1AuthMethodsGetBySecretRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authMethodsGetBySecret(e, s) {
      const t = await a.authMethodsGetBySecret(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the basic project information
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async basicMethodsGet(e, s) {
      const t = await a.basicMethodsGet(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update the basic project information
     * @param {string} projectId project id
     * @param {V1Basic} basic basic project information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async basicMethodsUpsert(e, s, t) {
      const r = await a.basicMethodsUpsert(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to delete the credit units data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creditUnitsMethodsDelete(e, s) {
      const t = await a.creditUnitsMethodsDelete(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to delete the credit units data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creditUnitsMethodsDeleteNetwork(e, s, t) {
      const r = await a.creditUnitsMethodsDeleteNetwork(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the credit units data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creditUnitsMethodsGet(e, s) {
      const t = await a.creditUnitsMethodsGet(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the credit units data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creditUnitsMethodsGetNetwork(e, s, t) {
      const r = await a.creditUnitsMethodsGetNetwork(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update the credit units data
     * @param {string} userId user id
     * @param {V1CreditUnits} creditUnits 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creditUnitsMethodsUpsert(e, s, t) {
      const r = await a.creditUnitsMethodsUpsert(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update the credit units data in a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {V1CreditUnits} creditUnits 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async creditUnitsMethodsUpsertNetwork(e, s, t, r) {
      const o = await a.creditUnitsMethodsUpsertNetwork(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to delete the custom key
     * @param {string} customKeyId custom key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async customKeyMethodsDelete(e, s) {
      const t = await a.customKeyMethodsDelete(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the custom key information
     * @param {string} customKeyId custom key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async customKeyMethodsGet(e, s) {
      const t = await a.customKeyMethodsGet(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update the custom key
     * @param {V1CustomKey} customKey custom key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async customKeyMethodsUpsert(e, s) {
      const t = await a.customKeyMethodsUpsert(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to delete a specific entitlment
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {string} entitlementId generally the of the entitlement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entitlementMethodsDelete(e, s, t, r) {
      const o = await a.entitlementMethodsDelete(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch a specific entitlment
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {string} entitlementId generally the of the entitlement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entitlementMethodsGet(e, s, t, r) {
      const o = await a.entitlementMethodsGet(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch all entitlments
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;near\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entitlementMethodsList(e, s, t) {
      const r = await a.entitlementMethodsList(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update a specific entitlment
     * @param {string} userId user id
     * @param {string} networkId network e.g.: \&quot;nft\&quot;
     * @param {string} entitlementId generally the of the entitlement
     * @param {V1Entitlement} entitlement entitlement info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async entitlementMethodsUpsert(e, s, t, r, o) {
      const n = await a.entitlementMethodsUpsert(e, s, t, r, o);
      return w(n, p, u, l);
    },
    /**
     * 
     * @summary Used to delete a dedicated gateway
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gatewayMethodsDelete(e, s) {
      const t = await a.gatewayMethodsDelete(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the dedicated gateway information
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gatewayMethodsGet(e, s) {
      const t = await a.gatewayMethodsGet(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update the dedicated gateway information
     * @param {string} projectId project id
     * @param {V1Gateway} gateway dedicated gateway data to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async gatewayMethodsUpsert(e, s, t) {
      const r = await a.gatewayMethodsUpsert(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to create a JWT
     * @param {string} projectId project id
     * @param {V1JWTDetail} jwt JWT Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async jWTMethodsCreate(e, s, t) {
      const r = await a.jWTMethodsCreate(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to delete a JWT
     * @param {string} projectId project id
     * @param {string} jwtId jwt id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async jWTMethodsDelete(e, s, t) {
      const r = await a.jWTMethodsDelete(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to list the JWTs in a project
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async jWTMethodsList(e, s) {
      const t = await a.jWTMethodsList(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to remove all limits existent within in a user which will force to use a template
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async limitsMethodsDelete(e, s) {
      const t = await a.limitsMethodsDelete(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to remove all limits existent within in a user which will force to use a template
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async limitsMethodsDeleteNetwork(e, s, t) {
      const r = await a.limitsMethodsDeleteNetwork(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch all limits in a tier
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async limitsMethodsList(e, s) {
      const t = await a.limitsMethodsList(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to a delete a network
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async networkMethodsDelete(e, s, t) {
      const r = await a.networkMethodsDelete(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to remove a subnet
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {'SUBNET_UNSPECIFIED' | 'SUBNET_MAINNET' | 'SUBNET_GOERLI' | 'SUBNET_GOERLI2' | 'SUBNET_SEPOLIA' | 'SUBNET_ALFAJORES' | 'SUBNET_MUMBAI' | 'SUBNET_FUJI' | 'SUBNET_TESTNET' | 'SUBNET_AMOY' | 'SUBNET_HOLESKY'} subnetId subnet to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async networkMethodsDeleteSubnet(e, s, t, r) {
      const o = await a.networkMethodsDeleteSubnet(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch a single network
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async networkMethodsGet(e, s, t) {
      const r = await a.networkMethodsGet(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch all networks
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async networkMethodsList(e, s) {
      const t = await a.networkMethodsList(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to insert/update a subnet
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {{ [key: string]: V1Subnet; }} subnets List of subnets to insert/update, the key should be a SubnetType bcoz the proto3 dont allow us to use enums as key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async networkMethodsUpdateSubnet(e, s, t, r) {
      const o = await a.networkMethodsUpdateSubnet(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update a network
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {V1Network} network // the full network data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async networkMethodsUpsert(e, s, t, r) {
      const o = await a.networkMethodsUpsert(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to create a network in the project
     * @param {string} projectId project id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {'SUBNET_UNSPECIFIED' | 'SUBNET_MAINNET' | 'SUBNET_GOERLI' | 'SUBNET_GOERLI2' | 'SUBNET_SEPOLIA' | 'SUBNET_ALFAJORES' | 'SUBNET_MUMBAI' | 'SUBNET_FUJI' | 'SUBNET_TESTNET' | 'SUBNET_AMOY' | 'SUBNET_HOLESKY'} subnet subnet to be inserted in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async networksMethodsCreate(e, s, t, r) {
      const o = await a.networksMethodsCreate(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to remove an item from a network in the project
     * @param {string} projectId project id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {'SUBNET_UNSPECIFIED' | 'SUBNET_MAINNET' | 'SUBNET_GOERLI' | 'SUBNET_GOERLI2' | 'SUBNET_SEPOLIA' | 'SUBNET_ALFAJORES' | 'SUBNET_MUMBAI' | 'SUBNET_FUJI' | 'SUBNET_TESTNET' | 'SUBNET_AMOY' | 'SUBNET_HOLESKY'} subnet subnet to be removed from the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async networksMethodsDelete(e, s, t, r) {
      const o = await a.networksMethodsDelete(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch a single the network
     * @param {string} projectId project id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async networksMethodsGet(e, s, t) {
      const r = await a.networksMethodsGet(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch all networks from the project
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async networksMethodsList(e, s) {
      const t = await a.networksMethodsList(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to delete a specific project
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectMethodsDelete(e, s) {
      const t = await a.projectMethodsDelete(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to remove a subnet
     * @param {string} projectId project id
     * @param {string} networkId network id
     * @param {Array<V1SubnetType>} subnets List of subnet to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectMethodsDeleteSubnets(e, s, t, r) {
      const o = await a.projectMethodsDeleteSubnets(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch a specific project
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectMethodsGet(e, s) {
      const t = await a.projectMethodsGet(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch all user projects
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectMethodsList(e, s) {
      const t = await a.projectMethodsList(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to insert a subnet
     * @param {string} projectId project id
     * @param {Array<V1SubnetType>} subnets List of subnet to update
     * @param {string} [networkId] network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectMethodsUpdateSubnets(e, s, t, r) {
      const o = await a.projectMethodsUpdateSubnets(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update a specific project
     * @param {V1Project} project project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectMethodsUpsert(e, s) {
      const t = await a.projectMethodsUpsert(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update a list of projects
     * @param {V1Projects} projects list of user projects
     * @param {string} [userId] user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async projectMethodsUpsertList(e, s, t) {
      const r = await a.projectMethodsUpsertList(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to delete quotas
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async quotasMethodsDelete(e, s) {
      const t = await a.quotasMethodsDelete(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch quotas information
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async quotasMethodsGet(e, s) {
      const t = await a.quotasMethodsGet(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update quotas information
     * @param {string} projectId project id
     * @param {V1Quotas} quotas quotas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async quotasMethodsUpsert(e, s, t) {
      const r = await a.quotasMethodsUpsert(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to delete rate limit informations
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rateLimitMethodsDelete(e, s) {
      const t = await a.rateLimitMethodsDelete(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch rate limit information
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rateLimitMethodsGet(e, s) {
      const t = await a.rateLimitMethodsGet(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update rate limit information
     * @param {string} projectId project id
     * @param {V1RateLimit} rateLimit rate limit data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async rateLimitMethodsUpsert(e, s, t) {
      const r = await a.rateLimitMethodsUpsert(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to generate a new secret
     * @param {string} projectId project id
     * @param {V1Security} security If this security object changes the secret will be other
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async securityMethodsGenerate(e, s, t) {
      const r = await a.securityMethodsGenerate(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the secret
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async securityMethodsGet(e, s) {
      const t = await a.securityMethodsGet(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to verify if the secret informed is valid
     * @param {string} projectId project id
     * @param {string} secret secret to be verified
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async securityMethodsVerify(e, s, t) {
      const r = await a.securityMethodsVerify(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the user service plan
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async serviceMethodsGet(e, s) {
      const t = await a.serviceMethodsGet(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update the user service plan
     * @param {V1Service} servicePlan the full service plan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async serviceMethodsUpsert(e, s) {
      const t = await a.serviceMethodsUpsert(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch all settings information
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async settingsMethodsList(e, s) {
      const t = await a.settingsMethodsList(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to delete the storage data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async storageMethodsDelete(e, s) {
      const t = await a.storageMethodsDelete(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to delete the storage data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async storageMethodsDeleteNetwork(e, s, t) {
      const r = await a.storageMethodsDeleteNetwork(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the storage data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async storageMethodsGet(e, s) {
      const t = await a.storageMethodsGet(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the storage data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async storageMethodsGetNetwork(e, s, t) {
      const r = await a.storageMethodsGetNetwork(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update the storage data
     * @param {string} userId user id
     * @param {V1Storage} storage storage data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async storageMethodsUpsert(e, s, t) {
      const r = await a.storageMethodsUpsert(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update the storage data in a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {V1Storage} storage storage data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async storageMethodsUpsertNetwork(e, s, t, r) {
      const o = await a.storageMethodsUpsertNetwork(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the template
     * @param {'TP_UNSPECIFIED' | 'TP_PLAN' | 'TP_NETWORKS' | 'TP_LIMITS' | 'TP_ADDONS' | 'TP_CREDIT_TABLE'} type template type
     * @param {string} templateId template id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async templateMethodsGet(e, s, t) {
      const r = await a.templateMethodsGet(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to list all templates by type
     * @param {'TP_UNSPECIFIED' | 'TP_PLAN' | 'TP_NETWORKS' | 'TP_LIMITS' | 'TP_ADDONS' | 'TP_CREDIT_TABLE'} type template type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async templateMethodsList(e, s) {
      const t = await a.templateMethodsList(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update the template
     * @param {V1Template} template the full template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async templateMethodsUpsert(e, s) {
      const t = await a.templateMethodsUpsert(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to delete the traffic data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async trafficMethodsDelete(e, s) {
      const t = await a.trafficMethodsDelete(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to delete the traffic data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async trafficMethodsDeleteNetwork(e, s, t) {
      const r = await a.trafficMethodsDeleteNetwork(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the traffic data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async trafficMethodsGet(e, s) {
      const t = await a.trafficMethodsGet(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the traffic data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async trafficMethodsGetNetwork(e, s, t) {
      const r = await a.trafficMethodsGetNetwork(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update the traffic data
     * @param {string} userId user id
     * @param {V1Traffic} traffic traffic data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async trafficMethodsUpsert(e, s, t) {
      const r = await a.trafficMethodsUpsert(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to create/update the traffic data in a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {V1Traffic} traffic traffic data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async trafficMethodsUpsertNetwork(e, s, t, r) {
      const o = await a.trafficMethodsUpsertNetwork(e, s, t, r);
      return w(o, p, u, l);
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usageTrackerMethodsGetCreditMap(e) {
      const s = await a.usageTrackerMethodsGetCreditMap(e);
      return w(s, p, u, l);
    },
    /**
     * 
     * @param {V1PublishRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usageTrackerMethodsPublishAtomic(e, s) {
      const t = await a.usageTrackerMethodsPublishAtomic(e, s);
      return w(t, p, u, l);
    },
    /**
     * 
     * @param {Array<string>} [keys] 
     * @param {string} [userId] user_id to use as cache hash to group the values in the same slot
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async usageTrackerMethodsQueryMemory(e, s, t) {
      const r = await a.usageTrackerMethodsQueryMemory(e, s, t);
      return w(r, p, u, l);
    },
    /**
     * 
     * @summary Used to fetch the User object using the user id
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async userMethodsGet(e, s) {
      const t = await a.userMethodsGet(e, s);
      return w(t, p, u, l);
    }
  };
}, _ = function(l, a, e) {
  const s = M(l);
  return {
    /**
     * 
     * @summary Used to create an allowlists in the project
     * @param {string} projectId project id
     * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to be created
     * @param {string} item item to be inserted in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistsMethodsCreate(t, r, o, n) {
      return s.allowlistsMethodsCreate(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to create an allowlists in the project with IPRange
     * @param {string} projectId project id
     * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to be created
     * @param {V1AllowIPRange} ipRange ip range to be inserted in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistsMethodsCreateIPRange(t, r, o, n) {
      return s.allowlistsMethodsCreateIPRange(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to remove an item from an allowlists in the project
     * @param {string} projectId project id
     * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to remove the item
     * @param {string} item item to be removed in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistsMethodsDelete(t, r, o, n) {
      return s.allowlistsMethodsDelete(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to create an allowlists in the project with IPRange
     * @param {string} projectId project id
     * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to be created
     * @param {V1AllowIPRange} ipRange ip range to be inserted in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistsMethodsDeleteIPRange(t, r, o, n) {
      return s.allowlistsMethodsDeleteIPRange(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to fetch a single the allowlist
     * @param {string} projectId project id
     * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to remove the item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistsMethodsGet(t, r, o) {
      return s.allowlistsMethodsGet(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to fetch all allowlists from the project
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistsMethodsList(t, r) {
      return s.allowlistsMethodsList(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to update the allowlists_overridden in the project
     * @param {string} projectId project id
     * @param {AllowlistsMethodsUpdateRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    allowlistsMethodsUpdate(t, r, o) {
      return s.allowlistsMethodsUpdate(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to delete the archive data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveMethodsDelete(t, r) {
      return s.archiveMethodsDelete(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to delete the archive data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveMethodsDeleteNetwork(t, r, o) {
      return s.archiveMethodsDeleteNetwork(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to fetch the archive data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveMethodsGet(t, r) {
      return s.archiveMethodsGet(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to fetch the archive data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveMethodsGetNetwork(t, r, o) {
      return s.archiveMethodsGetNetwork(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to create/update the archive data
     * @param {string} userId user id
     * @param {V1Archive} archive archive data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveMethodsUpsert(t, r, o) {
      return s.archiveMethodsUpsert(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to create/update the archive data in a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {V1Archive} archive archive data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    archiveMethodsUpsertNetwork(t, r, o, n) {
      return s.archiveMethodsUpsertNetwork(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to fetch the user Auth object using a custom key id
     * @param {string} customKeyId custom key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authMethodsGetByCustomKey(t, r) {
      return s.authMethodsGetByCustomKey(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to fetch the user Auth object using the project id (key) and the jwt id
     * @param {V1AuthMethodsGetByJwtRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authMethodsGetByJwt(t, r) {
      return s.authMethodsGetByJwt(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to fetch the user Auth object using the project id (key)
     * @param {V1AuthMethodsGetByPublicKeyRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authMethodsGetByPublicKey(t, r) {
      return s.authMethodsGetByPublicKey(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to fetch the user Auth object using the project id (key) and the secret
     * @param {V1AuthMethodsGetBySecretRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authMethodsGetBySecret(t, r) {
      return s.authMethodsGetBySecret(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to fetch the basic project information
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    basicMethodsGet(t, r) {
      return s.basicMethodsGet(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to create/update the basic project information
     * @param {string} projectId project id
     * @param {V1Basic} basic basic project information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    basicMethodsUpsert(t, r, o) {
      return s.basicMethodsUpsert(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to delete the credit units data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditUnitsMethodsDelete(t, r) {
      return s.creditUnitsMethodsDelete(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to delete the credit units data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditUnitsMethodsDeleteNetwork(t, r, o) {
      return s.creditUnitsMethodsDeleteNetwork(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to fetch the credit units data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditUnitsMethodsGet(t, r) {
      return s.creditUnitsMethodsGet(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to fetch the credit units data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditUnitsMethodsGetNetwork(t, r, o) {
      return s.creditUnitsMethodsGetNetwork(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to create/update the credit units data
     * @param {string} userId user id
     * @param {V1CreditUnits} creditUnits 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditUnitsMethodsUpsert(t, r, o) {
      return s.creditUnitsMethodsUpsert(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to create/update the credit units data in a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {V1CreditUnits} creditUnits 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    creditUnitsMethodsUpsertNetwork(t, r, o, n) {
      return s.creditUnitsMethodsUpsertNetwork(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to delete the custom key
     * @param {string} customKeyId custom key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customKeyMethodsDelete(t, r) {
      return s.customKeyMethodsDelete(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to fetch the custom key information
     * @param {string} customKeyId custom key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customKeyMethodsGet(t, r) {
      return s.customKeyMethodsGet(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to create/update the custom key
     * @param {V1CustomKey} customKey custom key id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    customKeyMethodsUpsert(t, r) {
      return s.customKeyMethodsUpsert(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to delete a specific entitlment
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {string} entitlementId generally the of the entitlement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entitlementMethodsDelete(t, r, o, n) {
      return s.entitlementMethodsDelete(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to fetch a specific entitlment
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {string} entitlementId generally the of the entitlement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entitlementMethodsGet(t, r, o, n) {
      return s.entitlementMethodsGet(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to fetch all entitlments
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;near\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entitlementMethodsList(t, r, o) {
      return s.entitlementMethodsList(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to create/update a specific entitlment
     * @param {string} userId user id
     * @param {string} networkId network e.g.: \&quot;nft\&quot;
     * @param {string} entitlementId generally the of the entitlement
     * @param {V1Entitlement} entitlement entitlement info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    entitlementMethodsUpsert(t, r, o, n, h) {
      return s.entitlementMethodsUpsert(t, r, o, n, h).then((c) => c(e, a));
    },
    /**
     * 
     * @summary Used to delete a dedicated gateway
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gatewayMethodsDelete(t, r) {
      return s.gatewayMethodsDelete(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to fetch the dedicated gateway information
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gatewayMethodsGet(t, r) {
      return s.gatewayMethodsGet(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to create/update the dedicated gateway information
     * @param {string} projectId project id
     * @param {V1Gateway} gateway dedicated gateway data to be updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gatewayMethodsUpsert(t, r, o) {
      return s.gatewayMethodsUpsert(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to create a JWT
     * @param {string} projectId project id
     * @param {V1JWTDetail} jwt JWT Data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    jWTMethodsCreate(t, r, o) {
      return s.jWTMethodsCreate(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to delete a JWT
     * @param {string} projectId project id
     * @param {string} jwtId jwt id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    jWTMethodsDelete(t, r, o) {
      return s.jWTMethodsDelete(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to list the JWTs in a project
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    jWTMethodsList(t, r) {
      return s.jWTMethodsList(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to remove all limits existent within in a user which will force to use a template
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    limitsMethodsDelete(t, r) {
      return s.limitsMethodsDelete(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to remove all limits existent within in a user which will force to use a template
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    limitsMethodsDeleteNetwork(t, r, o) {
      return s.limitsMethodsDeleteNetwork(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to fetch all limits in a tier
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    limitsMethodsList(t, r) {
      return s.limitsMethodsList(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to a delete a network
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networkMethodsDelete(t, r, o) {
      return s.networkMethodsDelete(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to remove a subnet
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {'SUBNET_UNSPECIFIED' | 'SUBNET_MAINNET' | 'SUBNET_GOERLI' | 'SUBNET_GOERLI2' | 'SUBNET_SEPOLIA' | 'SUBNET_ALFAJORES' | 'SUBNET_MUMBAI' | 'SUBNET_FUJI' | 'SUBNET_TESTNET' | 'SUBNET_AMOY' | 'SUBNET_HOLESKY'} subnetId subnet to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networkMethodsDeleteSubnet(t, r, o, n) {
      return s.networkMethodsDeleteSubnet(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to fetch a single network
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networkMethodsGet(t, r, o) {
      return s.networkMethodsGet(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to fetch all networks
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networkMethodsList(t, r) {
      return s.networkMethodsList(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to insert/update a subnet
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {{ [key: string]: V1Subnet; }} subnets List of subnets to insert/update, the key should be a SubnetType bcoz the proto3 dont allow us to use enums as key
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networkMethodsUpdateSubnet(t, r, o, n) {
      return s.networkMethodsUpdateSubnet(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to create/update a network
     * @param {string} userId user id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {V1Network} network // the full network data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networkMethodsUpsert(t, r, o, n) {
      return s.networkMethodsUpsert(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to create a network in the project
     * @param {string} projectId project id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {'SUBNET_UNSPECIFIED' | 'SUBNET_MAINNET' | 'SUBNET_GOERLI' | 'SUBNET_GOERLI2' | 'SUBNET_SEPOLIA' | 'SUBNET_ALFAJORES' | 'SUBNET_MUMBAI' | 'SUBNET_FUJI' | 'SUBNET_TESTNET' | 'SUBNET_AMOY' | 'SUBNET_HOLESKY'} subnet subnet to be inserted in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networksMethodsCreate(t, r, o, n) {
      return s.networksMethodsCreate(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to remove an item from a network in the project
     * @param {string} projectId project id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {'SUBNET_UNSPECIFIED' | 'SUBNET_MAINNET' | 'SUBNET_GOERLI' | 'SUBNET_GOERLI2' | 'SUBNET_SEPOLIA' | 'SUBNET_ALFAJORES' | 'SUBNET_MUMBAI' | 'SUBNET_FUJI' | 'SUBNET_TESTNET' | 'SUBNET_AMOY' | 'SUBNET_HOLESKY'} subnet subnet to be removed from the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networksMethodsDelete(t, r, o, n) {
      return s.networksMethodsDelete(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to fetch a single the network
     * @param {string} projectId project id
     * @param {string} networkId network e.g: \&quot;eth\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networksMethodsGet(t, r, o) {
      return s.networksMethodsGet(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to fetch all networks from the project
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    networksMethodsList(t, r) {
      return s.networksMethodsList(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to delete a specific project
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectMethodsDelete(t, r) {
      return s.projectMethodsDelete(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to remove a subnet
     * @param {string} projectId project id
     * @param {string} networkId network id
     * @param {Array<V1SubnetType>} subnets List of subnet to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectMethodsDeleteSubnets(t, r, o, n) {
      return s.projectMethodsDeleteSubnets(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to fetch a specific project
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectMethodsGet(t, r) {
      return s.projectMethodsGet(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to fetch all user projects
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectMethodsList(t, r) {
      return s.projectMethodsList(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to insert a subnet
     * @param {string} projectId project id
     * @param {Array<V1SubnetType>} subnets List of subnet to update
     * @param {string} [networkId] network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectMethodsUpdateSubnets(t, r, o, n) {
      return s.projectMethodsUpdateSubnets(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to create/update a specific project
     * @param {V1Project} project project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectMethodsUpsert(t, r) {
      return s.projectMethodsUpsert(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to create/update a list of projects
     * @param {V1Projects} projects list of user projects
     * @param {string} [userId] user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    projectMethodsUpsertList(t, r, o) {
      return s.projectMethodsUpsertList(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to delete quotas
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quotasMethodsDelete(t, r) {
      return s.quotasMethodsDelete(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to fetch quotas information
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quotasMethodsGet(t, r) {
      return s.quotasMethodsGet(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to create/update quotas information
     * @param {string} projectId project id
     * @param {V1Quotas} quotas quotas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    quotasMethodsUpsert(t, r, o) {
      return s.quotasMethodsUpsert(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to delete rate limit informations
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rateLimitMethodsDelete(t, r) {
      return s.rateLimitMethodsDelete(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to fetch rate limit information
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rateLimitMethodsGet(t, r) {
      return s.rateLimitMethodsGet(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to create/update rate limit information
     * @param {string} projectId project id
     * @param {V1RateLimit} rateLimit rate limit data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    rateLimitMethodsUpsert(t, r, o) {
      return s.rateLimitMethodsUpsert(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to generate a new secret
     * @param {string} projectId project id
     * @param {V1Security} security If this security object changes the secret will be other
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    securityMethodsGenerate(t, r, o) {
      return s.securityMethodsGenerate(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to fetch the secret
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    securityMethodsGet(t, r) {
      return s.securityMethodsGet(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to verify if the secret informed is valid
     * @param {string} projectId project id
     * @param {string} secret secret to be verified
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    securityMethodsVerify(t, r, o) {
      return s.securityMethodsVerify(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to fetch the user service plan
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceMethodsGet(t, r) {
      return s.serviceMethodsGet(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to create/update the user service plan
     * @param {V1Service} servicePlan the full service plan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    serviceMethodsUpsert(t, r) {
      return s.serviceMethodsUpsert(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to fetch all settings information
     * @param {string} projectId project id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    settingsMethodsList(t, r) {
      return s.settingsMethodsList(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to delete the storage data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    storageMethodsDelete(t, r) {
      return s.storageMethodsDelete(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to delete the storage data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    storageMethodsDeleteNetwork(t, r, o) {
      return s.storageMethodsDeleteNetwork(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to fetch the storage data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    storageMethodsGet(t, r) {
      return s.storageMethodsGet(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to fetch the storage data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    storageMethodsGetNetwork(t, r, o) {
      return s.storageMethodsGetNetwork(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to create/update the storage data
     * @param {string} userId user id
     * @param {V1Storage} storage storage data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    storageMethodsUpsert(t, r, o) {
      return s.storageMethodsUpsert(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to create/update the storage data in a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {V1Storage} storage storage data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    storageMethodsUpsertNetwork(t, r, o, n) {
      return s.storageMethodsUpsertNetwork(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @summary Used to fetch the template
     * @param {'TP_UNSPECIFIED' | 'TP_PLAN' | 'TP_NETWORKS' | 'TP_LIMITS' | 'TP_ADDONS' | 'TP_CREDIT_TABLE'} type template type
     * @param {string} templateId template id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templateMethodsGet(t, r, o) {
      return s.templateMethodsGet(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to list all templates by type
     * @param {'TP_UNSPECIFIED' | 'TP_PLAN' | 'TP_NETWORKS' | 'TP_LIMITS' | 'TP_ADDONS' | 'TP_CREDIT_TABLE'} type template type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templateMethodsList(t, r) {
      return s.templateMethodsList(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to create/update the template
     * @param {V1Template} template the full template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    templateMethodsUpsert(t, r) {
      return s.templateMethodsUpsert(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to delete the traffic data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trafficMethodsDelete(t, r) {
      return s.trafficMethodsDelete(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to delete the traffic data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trafficMethodsDeleteNetwork(t, r, o) {
      return s.trafficMethodsDeleteNetwork(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to fetch the traffic data
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trafficMethodsGet(t, r) {
      return s.trafficMethodsGet(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @summary Used to fetch the traffic data from a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trafficMethodsGetNetwork(t, r, o) {
      return s.trafficMethodsGetNetwork(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to create/update the traffic data
     * @param {string} userId user id
     * @param {V1Traffic} traffic traffic data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trafficMethodsUpsert(t, r, o) {
      return s.trafficMethodsUpsert(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to create/update the traffic data in a specific network
     * @param {string} userId user id
     * @param {string} networkId network id
     * @param {V1Traffic} traffic traffic data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    trafficMethodsUpsertNetwork(t, r, o, n) {
      return s.trafficMethodsUpsertNetwork(t, r, o, n).then((h) => h(e, a));
    },
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usageTrackerMethodsGetCreditMap(t) {
      return s.usageTrackerMethodsGetCreditMap(t).then((r) => r(e, a));
    },
    /**
     * 
     * @param {V1PublishRequest} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usageTrackerMethodsPublishAtomic(t, r) {
      return s.usageTrackerMethodsPublishAtomic(t, r).then((o) => o(e, a));
    },
    /**
     * 
     * @param {Array<string>} [keys] 
     * @param {string} [userId] user_id to use as cache hash to group the values in the same slot
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    usageTrackerMethodsQueryMemory(t, r, o) {
      return s.usageTrackerMethodsQueryMemory(t, r, o).then((n) => n(e, a));
    },
    /**
     * 
     * @summary Used to fetch the User object using the user id
     * @param {string} userId user id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userMethodsGet(t, r) {
      return s.userMethodsGet(t, r).then((o) => o(e, a));
    }
  };
};
class $ extends k {
  /**
   * 
   * @summary Used to create an allowlists in the project
   * @param {string} projectId project id
   * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to be created
   * @param {string} item item to be inserted in the list
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  allowlistsMethodsCreate(a, e, s, t) {
    return M(this.configuration).allowlistsMethodsCreate(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create an allowlists in the project with IPRange
   * @param {string} projectId project id
   * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to be created
   * @param {V1AllowIPRange} ipRange ip range to be inserted in the list
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  allowlistsMethodsCreateIPRange(a, e, s, t) {
    return M(this.configuration).allowlistsMethodsCreateIPRange(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to remove an item from an allowlists in the project
   * @param {string} projectId project id
   * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to remove the item
   * @param {string} item item to be removed in the list
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  allowlistsMethodsDelete(a, e, s, t) {
    return M(this.configuration).allowlistsMethodsDelete(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create an allowlists in the project with IPRange
   * @param {string} projectId project id
   * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to be created
   * @param {V1AllowIPRange} ipRange ip range to be inserted in the list
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  allowlistsMethodsDeleteIPRange(a, e, s, t) {
    return M(this.configuration).allowlistsMethodsDeleteIPRange(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch a single the allowlist
   * @param {string} projectId project id
   * @param {'AL_UNSPECIFIED' | 'AL_ADDRESSES' | 'AL_USER_AGENTS' | 'AL_ORIGINS' | 'AL_METHODS' | 'AL_IPS'} listType enum Type to indicate which list is to remove the item
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  allowlistsMethodsGet(a, e, s) {
    return M(this.configuration).allowlistsMethodsGet(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch all allowlists from the project
   * @param {string} projectId project id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  allowlistsMethodsList(a, e) {
    return M(this.configuration).allowlistsMethodsList(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to update the allowlists_overridden in the project
   * @param {string} projectId project id
   * @param {AllowlistsMethodsUpdateRequest} body 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  allowlistsMethodsUpdate(a, e, s) {
    return M(this.configuration).allowlistsMethodsUpdate(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to delete the archive data
   * @param {string} userId user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  archiveMethodsDelete(a, e) {
    return M(this.configuration).archiveMethodsDelete(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to delete the archive data from a specific network
   * @param {string} userId user id
   * @param {string} networkId network id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  archiveMethodsDeleteNetwork(a, e, s) {
    return M(this.configuration).archiveMethodsDeleteNetwork(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the archive data
   * @param {string} userId user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  archiveMethodsGet(a, e) {
    return M(this.configuration).archiveMethodsGet(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the archive data from a specific network
   * @param {string} userId user id
   * @param {string} networkId network id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  archiveMethodsGetNetwork(a, e, s) {
    return M(this.configuration).archiveMethodsGetNetwork(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update the archive data
   * @param {string} userId user id
   * @param {V1Archive} archive archive data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  archiveMethodsUpsert(a, e, s) {
    return M(this.configuration).archiveMethodsUpsert(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update the archive data in a specific network
   * @param {string} userId user id
   * @param {string} networkId network id
   * @param {V1Archive} archive archive data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  archiveMethodsUpsertNetwork(a, e, s, t) {
    return M(this.configuration).archiveMethodsUpsertNetwork(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the user Auth object using a custom key id
   * @param {string} customKeyId custom key id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  authMethodsGetByCustomKey(a, e) {
    return M(this.configuration).authMethodsGetByCustomKey(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the user Auth object using the project id (key) and the jwt id
   * @param {V1AuthMethodsGetByJwtRequest} body 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  authMethodsGetByJwt(a, e) {
    return M(this.configuration).authMethodsGetByJwt(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the user Auth object using the project id (key)
   * @param {V1AuthMethodsGetByPublicKeyRequest} body 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  authMethodsGetByPublicKey(a, e) {
    return M(this.configuration).authMethodsGetByPublicKey(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the user Auth object using the project id (key) and the secret
   * @param {V1AuthMethodsGetBySecretRequest} body 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  authMethodsGetBySecret(a, e) {
    return M(this.configuration).authMethodsGetBySecret(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the basic project information
   * @param {string} projectId project id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  basicMethodsGet(a, e) {
    return M(this.configuration).basicMethodsGet(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update the basic project information
   * @param {string} projectId project id
   * @param {V1Basic} basic basic project information
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  basicMethodsUpsert(a, e, s) {
    return M(this.configuration).basicMethodsUpsert(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to delete the credit units data
   * @param {string} userId user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  creditUnitsMethodsDelete(a, e) {
    return M(this.configuration).creditUnitsMethodsDelete(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to delete the credit units data from a specific network
   * @param {string} userId user id
   * @param {string} networkId network id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  creditUnitsMethodsDeleteNetwork(a, e, s) {
    return M(this.configuration).creditUnitsMethodsDeleteNetwork(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the credit units data
   * @param {string} userId user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  creditUnitsMethodsGet(a, e) {
    return M(this.configuration).creditUnitsMethodsGet(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the credit units data from a specific network
   * @param {string} userId user id
   * @param {string} networkId network id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  creditUnitsMethodsGetNetwork(a, e, s) {
    return M(this.configuration).creditUnitsMethodsGetNetwork(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update the credit units data
   * @param {string} userId user id
   * @param {V1CreditUnits} creditUnits 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  creditUnitsMethodsUpsert(a, e, s) {
    return M(this.configuration).creditUnitsMethodsUpsert(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update the credit units data in a specific network
   * @param {string} userId user id
   * @param {string} networkId network id
   * @param {V1CreditUnits} creditUnits 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  creditUnitsMethodsUpsertNetwork(a, e, s, t) {
    return M(this.configuration).creditUnitsMethodsUpsertNetwork(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to delete the custom key
   * @param {string} customKeyId custom key id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  customKeyMethodsDelete(a, e) {
    return M(this.configuration).customKeyMethodsDelete(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the custom key information
   * @param {string} customKeyId custom key id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  customKeyMethodsGet(a, e) {
    return M(this.configuration).customKeyMethodsGet(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update the custom key
   * @param {V1CustomKey} customKey custom key id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  customKeyMethodsUpsert(a, e) {
    return M(this.configuration).customKeyMethodsUpsert(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to delete a specific entitlment
   * @param {string} userId user id
   * @param {string} networkId network e.g: \&quot;eth\&quot;
   * @param {string} entitlementId generally the of the entitlement
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  entitlementMethodsDelete(a, e, s, t) {
    return M(this.configuration).entitlementMethodsDelete(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch a specific entitlment
   * @param {string} userId user id
   * @param {string} networkId network e.g: \&quot;eth\&quot;
   * @param {string} entitlementId generally the of the entitlement
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  entitlementMethodsGet(a, e, s, t) {
    return M(this.configuration).entitlementMethodsGet(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch all entitlments
   * @param {string} userId user id
   * @param {string} networkId network e.g: \&quot;near\&quot;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  entitlementMethodsList(a, e, s) {
    return M(this.configuration).entitlementMethodsList(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update a specific entitlment
   * @param {string} userId user id
   * @param {string} networkId network e.g.: \&quot;nft\&quot;
   * @param {string} entitlementId generally the of the entitlement
   * @param {V1Entitlement} entitlement entitlement info
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  entitlementMethodsUpsert(a, e, s, t, r) {
    return M(this.configuration).entitlementMethodsUpsert(a, e, s, t, r).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to delete a dedicated gateway
   * @param {string} projectId project id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  gatewayMethodsDelete(a, e) {
    return M(this.configuration).gatewayMethodsDelete(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the dedicated gateway information
   * @param {string} projectId project id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  gatewayMethodsGet(a, e) {
    return M(this.configuration).gatewayMethodsGet(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update the dedicated gateway information
   * @param {string} projectId project id
   * @param {V1Gateway} gateway dedicated gateway data to be updated
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  gatewayMethodsUpsert(a, e, s) {
    return M(this.configuration).gatewayMethodsUpsert(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create a JWT
   * @param {string} projectId project id
   * @param {V1JWTDetail} jwt JWT Data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  jWTMethodsCreate(a, e, s) {
    return M(this.configuration).jWTMethodsCreate(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to delete a JWT
   * @param {string} projectId project id
   * @param {string} jwtId jwt id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  jWTMethodsDelete(a, e, s) {
    return M(this.configuration).jWTMethodsDelete(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to list the JWTs in a project
   * @param {string} projectId project id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  jWTMethodsList(a, e) {
    return M(this.configuration).jWTMethodsList(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to remove all limits existent within in a user which will force to use a template
   * @param {string} userId user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  limitsMethodsDelete(a, e) {
    return M(this.configuration).limitsMethodsDelete(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to remove all limits existent within in a user which will force to use a template
   * @param {string} userId user id
   * @param {string} networkId network id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  limitsMethodsDeleteNetwork(a, e, s) {
    return M(this.configuration).limitsMethodsDeleteNetwork(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch all limits in a tier
   * @param {string} userId user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  limitsMethodsList(a, e) {
    return M(this.configuration).limitsMethodsList(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to a delete a network
   * @param {string} userId user id
   * @param {string} networkId network e.g: \&quot;eth\&quot;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  networkMethodsDelete(a, e, s) {
    return M(this.configuration).networkMethodsDelete(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to remove a subnet
   * @param {string} userId user id
   * @param {string} networkId network e.g: \&quot;eth\&quot;
   * @param {'SUBNET_UNSPECIFIED' | 'SUBNET_MAINNET' | 'SUBNET_GOERLI' | 'SUBNET_GOERLI2' | 'SUBNET_SEPOLIA' | 'SUBNET_ALFAJORES' | 'SUBNET_MUMBAI' | 'SUBNET_FUJI' | 'SUBNET_TESTNET' | 'SUBNET_AMOY' | 'SUBNET_HOLESKY'} subnetId subnet to remove
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  networkMethodsDeleteSubnet(a, e, s, t) {
    return M(this.configuration).networkMethodsDeleteSubnet(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch a single network
   * @param {string} userId user id
   * @param {string} networkId network e.g: \&quot;eth\&quot;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  networkMethodsGet(a, e, s) {
    return M(this.configuration).networkMethodsGet(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch all networks
   * @param {string} userId user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  networkMethodsList(a, e) {
    return M(this.configuration).networkMethodsList(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to insert/update a subnet
   * @param {string} userId user id
   * @param {string} networkId network e.g: \&quot;eth\&quot;
   * @param {{ [key: string]: V1Subnet; }} subnets List of subnets to insert/update, the key should be a SubnetType bcoz the proto3 dont allow us to use enums as key
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  networkMethodsUpdateSubnet(a, e, s, t) {
    return M(this.configuration).networkMethodsUpdateSubnet(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update a network
   * @param {string} userId user id
   * @param {string} networkId network e.g: \&quot;eth\&quot;
   * @param {V1Network} network // the full network data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  networkMethodsUpsert(a, e, s, t) {
    return M(this.configuration).networkMethodsUpsert(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create a network in the project
   * @param {string} projectId project id
   * @param {string} networkId network e.g: \&quot;eth\&quot;
   * @param {'SUBNET_UNSPECIFIED' | 'SUBNET_MAINNET' | 'SUBNET_GOERLI' | 'SUBNET_GOERLI2' | 'SUBNET_SEPOLIA' | 'SUBNET_ALFAJORES' | 'SUBNET_MUMBAI' | 'SUBNET_FUJI' | 'SUBNET_TESTNET' | 'SUBNET_AMOY' | 'SUBNET_HOLESKY'} subnet subnet to be inserted in the list
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  networksMethodsCreate(a, e, s, t) {
    return M(this.configuration).networksMethodsCreate(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to remove an item from a network in the project
   * @param {string} projectId project id
   * @param {string} networkId network e.g: \&quot;eth\&quot;
   * @param {'SUBNET_UNSPECIFIED' | 'SUBNET_MAINNET' | 'SUBNET_GOERLI' | 'SUBNET_GOERLI2' | 'SUBNET_SEPOLIA' | 'SUBNET_ALFAJORES' | 'SUBNET_MUMBAI' | 'SUBNET_FUJI' | 'SUBNET_TESTNET' | 'SUBNET_AMOY' | 'SUBNET_HOLESKY'} subnet subnet to be removed from the list
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  networksMethodsDelete(a, e, s, t) {
    return M(this.configuration).networksMethodsDelete(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch a single the network
   * @param {string} projectId project id
   * @param {string} networkId network e.g: \&quot;eth\&quot;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  networksMethodsGet(a, e, s) {
    return M(this.configuration).networksMethodsGet(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch all networks from the project
   * @param {string} projectId project id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  networksMethodsList(a, e) {
    return M(this.configuration).networksMethodsList(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to delete a specific project
   * @param {string} projectId project id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  projectMethodsDelete(a, e) {
    return M(this.configuration).projectMethodsDelete(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to remove a subnet
   * @param {string} projectId project id
   * @param {string} networkId network id
   * @param {Array<V1SubnetType>} subnets List of subnet to remove
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  projectMethodsDeleteSubnets(a, e, s, t) {
    return M(this.configuration).projectMethodsDeleteSubnets(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch a specific project
   * @param {string} projectId project id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  projectMethodsGet(a, e) {
    return M(this.configuration).projectMethodsGet(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch all user projects
   * @param {string} userId user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  projectMethodsList(a, e) {
    return M(this.configuration).projectMethodsList(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to insert a subnet
   * @param {string} projectId project id
   * @param {Array<V1SubnetType>} subnets List of subnet to update
   * @param {string} [networkId] network id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  projectMethodsUpdateSubnets(a, e, s, t) {
    return M(this.configuration).projectMethodsUpdateSubnets(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update a specific project
   * @param {V1Project} project project id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  projectMethodsUpsert(a, e) {
    return M(this.configuration).projectMethodsUpsert(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update a list of projects
   * @param {V1Projects} projects list of user projects
   * @param {string} [userId] user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  projectMethodsUpsertList(a, e, s) {
    return M(this.configuration).projectMethodsUpsertList(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to delete quotas
   * @param {string} projectId project id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  quotasMethodsDelete(a, e) {
    return M(this.configuration).quotasMethodsDelete(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch quotas information
   * @param {string} projectId project id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  quotasMethodsGet(a, e) {
    return M(this.configuration).quotasMethodsGet(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update quotas information
   * @param {string} projectId project id
   * @param {V1Quotas} quotas quotas
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  quotasMethodsUpsert(a, e, s) {
    return M(this.configuration).quotasMethodsUpsert(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to delete rate limit informations
   * @param {string} projectId project id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  rateLimitMethodsDelete(a, e) {
    return M(this.configuration).rateLimitMethodsDelete(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch rate limit information
   * @param {string} projectId project id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  rateLimitMethodsGet(a, e) {
    return M(this.configuration).rateLimitMethodsGet(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update rate limit information
   * @param {string} projectId project id
   * @param {V1RateLimit} rateLimit rate limit data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  rateLimitMethodsUpsert(a, e, s) {
    return M(this.configuration).rateLimitMethodsUpsert(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to generate a new secret
   * @param {string} projectId project id
   * @param {V1Security} security If this security object changes the secret will be other
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  securityMethodsGenerate(a, e, s) {
    return M(this.configuration).securityMethodsGenerate(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the secret
   * @param {string} projectId 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  securityMethodsGet(a, e) {
    return M(this.configuration).securityMethodsGet(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to verify if the secret informed is valid
   * @param {string} projectId project id
   * @param {string} secret secret to be verified
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  securityMethodsVerify(a, e, s) {
    return M(this.configuration).securityMethodsVerify(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the user service plan
   * @param {string} userId user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  serviceMethodsGet(a, e) {
    return M(this.configuration).serviceMethodsGet(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update the user service plan
   * @param {V1Service} servicePlan the full service plan
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  serviceMethodsUpsert(a, e) {
    return M(this.configuration).serviceMethodsUpsert(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch all settings information
   * @param {string} projectId project id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  settingsMethodsList(a, e) {
    return M(this.configuration).settingsMethodsList(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to delete the storage data
   * @param {string} userId user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  storageMethodsDelete(a, e) {
    return M(this.configuration).storageMethodsDelete(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to delete the storage data from a specific network
   * @param {string} userId user id
   * @param {string} networkId network id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  storageMethodsDeleteNetwork(a, e, s) {
    return M(this.configuration).storageMethodsDeleteNetwork(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the storage data
   * @param {string} userId user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  storageMethodsGet(a, e) {
    return M(this.configuration).storageMethodsGet(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the storage data from a specific network
   * @param {string} userId user id
   * @param {string} networkId network id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  storageMethodsGetNetwork(a, e, s) {
    return M(this.configuration).storageMethodsGetNetwork(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update the storage data
   * @param {string} userId user id
   * @param {V1Storage} storage storage data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  storageMethodsUpsert(a, e, s) {
    return M(this.configuration).storageMethodsUpsert(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update the storage data in a specific network
   * @param {string} userId user id
   * @param {string} networkId network id
   * @param {V1Storage} storage storage data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  storageMethodsUpsertNetwork(a, e, s, t) {
    return M(this.configuration).storageMethodsUpsertNetwork(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the template
   * @param {'TP_UNSPECIFIED' | 'TP_PLAN' | 'TP_NETWORKS' | 'TP_LIMITS' | 'TP_ADDONS' | 'TP_CREDIT_TABLE'} type template type
   * @param {string} templateId template id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  templateMethodsGet(a, e, s) {
    return M(this.configuration).templateMethodsGet(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to list all templates by type
   * @param {'TP_UNSPECIFIED' | 'TP_PLAN' | 'TP_NETWORKS' | 'TP_LIMITS' | 'TP_ADDONS' | 'TP_CREDIT_TABLE'} type template type
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  templateMethodsList(a, e) {
    return M(this.configuration).templateMethodsList(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update the template
   * @param {V1Template} template the full template
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  templateMethodsUpsert(a, e) {
    return M(this.configuration).templateMethodsUpsert(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to delete the traffic data
   * @param {string} userId user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  trafficMethodsDelete(a, e) {
    return M(this.configuration).trafficMethodsDelete(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to delete the traffic data from a specific network
   * @param {string} userId user id
   * @param {string} networkId network id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  trafficMethodsDeleteNetwork(a, e, s) {
    return M(this.configuration).trafficMethodsDeleteNetwork(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the traffic data
   * @param {string} userId user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  trafficMethodsGet(a, e) {
    return M(this.configuration).trafficMethodsGet(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the traffic data from a specific network
   * @param {string} userId user id
   * @param {string} networkId network id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  trafficMethodsGetNetwork(a, e, s) {
    return M(this.configuration).trafficMethodsGetNetwork(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update the traffic data
   * @param {string} userId user id
   * @param {V1Traffic} traffic traffic data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  trafficMethodsUpsert(a, e, s) {
    return M(this.configuration).trafficMethodsUpsert(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to create/update the traffic data in a specific network
   * @param {string} userId user id
   * @param {string} networkId network id
   * @param {V1Traffic} traffic traffic data
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  trafficMethodsUpsertNetwork(a, e, s, t) {
    return M(this.configuration).trafficMethodsUpsertNetwork(a, e, s, t).then((r) => r(this.axios, this.basePath));
  }
  /**
   * 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  usageTrackerMethodsGetCreditMap(a) {
    return M(this.configuration).usageTrackerMethodsGetCreditMap(a).then((e) => e(this.axios, this.basePath));
  }
  /**
   * 
   * @param {V1PublishRequest} body 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  usageTrackerMethodsPublishAtomic(a, e) {
    return M(this.configuration).usageTrackerMethodsPublishAtomic(a, e).then((s) => s(this.axios, this.basePath));
  }
  /**
   * 
   * @param {Array<string>} [keys] 
   * @param {string} [userId] user_id to use as cache hash to group the values in the same slot
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  usageTrackerMethodsQueryMemory(a, e, s) {
    return M(this.configuration).usageTrackerMethodsQueryMemory(a, e, s).then((t) => t(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Used to fetch the User object using the user id
   * @param {string} userId user id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  userMethodsGet(a, e) {
    return M(this.configuration).userMethodsGet(a, e).then((s) => s(this.axios, this.basePath));
  }
}
class q {
  constructor(a = {}) {
    /**
     * parameter for apiKey security
     * @param name security name
     * @memberof Configuration
     */
    P(this, "apiKey");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    P(this, "username");
    /**
     * parameter for basic security
     *
     * @type {string}
     * @memberof Configuration
     */
    P(this, "password");
    /**
     * parameter for oauth2 security
     * @param name security name
     * @param scopes oauth2 scope
     * @memberof Configuration
     */
    P(this, "accessToken");
    /**
     * override base path
     *
     * @type {string}
     * @memberof Configuration
     */
    P(this, "basePath");
    /**
     * base options for axios calls
     *
     * @type {any}
     * @memberof Configuration
     */
    P(this, "baseOptions");
    /**
     * The FormData constructor that will be used to create multipart form data
     * requests. You can inject this here so that execution environments that
     * do not support the FormData class can still run the generated client.
     *
     * @type {new () => FormData}
     */
    P(this, "formDataCtor");
    this.apiKey = a.apiKey, this.username = a.username, this.password = a.password, this.accessToken = a.accessToken, this.basePath = a.basePath, this.baseOptions = a.baseOptions, this.formDataCtor = a.formDataCtor;
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(a) {
    const e = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return a !== null && (e.test(a) || a.toLowerCase() === "application/json-patch+json");
  }
}
export {
  q as Configuration,
  $ as DefaultApi,
  A as DefaultApiAxiosParamCreator,
  _ as DefaultApiFactory,
  M as DefaultApiFp,
  S as ProjectRole,
  L as ServiceAddon,
  C as ServicePlanv1Status,
  v as ServiceTier,
  E as V1ALType,
  N as V1CreditPlan,
  Q as V1Operators,
  g as V1SubnetType,
  B as V1TemplateType
};
